import { useEffect, useRef } from 'react';

const LiveKitLocalPreview = ({ track }) => {
	const videoRef = useRef(null);

	useEffect(() => {
		if (!track || !videoRef.current) {
			return undefined;
		}

		const element = videoRef.current;

		track.attach(element);

		return () => track.detach(element);
	}, [track]);

	return <video ref={videoRef} autoPlay muted playsInline className="livekit-video" />;
};

export default LiveKitLocalPreview;
